import { CaptionedImageFragment } from "graphql/generated-types";
import CaptionedImage from "./CaptionedImage";
import ColumnBlock from "./ColumnBlock";

type RichtextWithImageProps = {
	image: CaptionedImageFragment;
	richtext?: string | null;
};

const RichText: React.FC<RichtextWithImageProps> = ({ image, richtext }) => {
	const captionedImage = <CaptionedImage block={image} />;

	if (!richtext) {
		return <div className="w-full">{captionedImage}</div>;
	}

	return (
		<ColumnBlock
			left={captionedImage}
			right={<div className="prose max-w-none" dangerouslySetInnerHTML={{ __html: richtext }} />}
		/>
	);
};

export default RichText;
